module.exports = __webpack_public_path__ + "static/media/YF20_2.5ce22a0c.jpg";